import type { MDXContent } from 'mdx/types';

import { Wrapper, type WrapperComponent } from './Wrapper';
import { DEFAULT_SIZE } from './size';

export const WrapperRenderer = ({
  children,
  document: Document,
}: {
  children: WrapperComponent;
  document: MDXContent;
}) => (
  <Document
    components={{
      Layout: ({ children: content }) => (
        <Wrapper component={children} size={DEFAULT_SIZE}>
          {content}
        </Wrapper>
      ),
    }}
  />
);
